module.exports = __webpack_public_path__ + "img/swatch-5.b7478242.png";